module.exports = __webpack_public_path__ + "static/media/dog-person-petting-svgrepo-com.7b388827.svg";